<template>
  <div class="">
    <v-tabs v-model="subTabsListing" class=" mt-0">
      <v-tab class=" body-2">Agences</v-tab>
      <v-tab>
        Agents
      </v-tab>
      <v-tab-item>
        <!--   AGENCIES     -->
        <v-progress-circular
            v-if="logs.loading"
            indeterminate
            color="primary"
            class="my-10 mx-10"
        ></v-progress-circular>
        <v-row v-else>

          <v-col cols="2" style="border-right: 1px solid lightgrey;">
            <div v-if="logs.items == null || logs.items.length == 0 " class="pa-3">Aucune mise à jour disponible
            </div>
            <v-list>
              <v-list-item-group
                  mandatory
                  v-model="logs.selected"
                  color="primary">
                <v-list-item
                    v-for="(item, i) in logs.items"
                    :key="i"
                    @click="selectLog(item,i)"
                    :value="item">

                  <v-list-item-content>

                    <div class="justify-start align-center d-flex flex-row ">

                      <div class="d-flex flex-column mr-2">
                        <span class="grey--text caption ">{{ item.version }}</span>
                        <site-label class="ml-auto" :sitename="item.userId == null ? 'HLagons' : 'Smartresas'"/>
                      </div>
                      <div class="body-2 ">
                        <div class="d-flex flex-row">
                              <span class="font-weight-medium"> {{
                                  _formatDate(new Date(item.creationDate), "dd/MM/yyyy 'à' HH:mm")
                                }}  </span><span class="mx-1 font-weight-regular">par</span>
                          <span class="font-weight-medium mr-2" v-if="item.userId != null">{{
                              initial(item.userName)
                            }}</span>
                          <span class="font-weight-medium mr-2" v-else>{{ initial(item.agentName) }}</span>

                        </div>

                      </div>

                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-col>
          <v-col cols="10">
            <div class="mx-lg-12 mx-md-0">
              <comparator-json :obj2="logs.oldestSelected" :obj1="logs.newestSelected"
                               v-if="logs.newestSelected != null && logs.selected != null"
                               :hide-fields="['version','password','modifyDate','data','logType']"
                               class:
              />

            </div>
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item>

        <!--   AGENTS     -->
        <div class="px-3">
          <v-progress-circular
              v-if="agentLogs.loading"
              indeterminate
              color="primary"
              class="my-10 mx-10"
          ></v-progress-circular>
          <v-row v-else style="border-top:1px solid lightgrey;">
            <v-col cols="4">
              <v-row>
                <v-col cols="6" style="border-right:1px solid lightgrey;">

                  <v-list-item-group
                      v-model="agentLogs.selected"
                      mandatory
                      color="primary">
                    <v-list-item
                        v-for="(item, i) in agentLogs.items"
                        :key="i"
                        @click=" selectAgent(item,i)"
                        active-class=""
                        :value="item">

                      <v-list-item-content>
                        <div class="d-flex  justify-start align-left ">
                      <span class="body-2">{{ item.data.lastname }} {{ item.data.firstname }}
                      </span>
                          <div v-if="item.lastUpdate != null" class="body-2">

                        <span class="mx-2 caption">• {{
                            item.lastUpdate ? _formatDate(new Date(item.lastUpdate), " dd/MM/yyyy 'à' HH:mm") : ''
                          }}</span>

                          </div>
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>

                </v-col>
                <v-col cols="6" v-if=" agentLogs.selected !=null && agentLogs.selected.logs.length ==0 ">
                  <span>Aucune mise à jour</span>
                </v-col>
                <v-col cols="4" v-else-if="agentLogs.selected !=null" style="border-right: 1px solid lightgrey;">

                  <v-list-item-group
                      v-model="agentLogs.selectedVersion"
                      color="primary"
                  >
                    <v-list-item
                        v-for="(item, i) in agentLogs.selected.logs"
                        :key="i"
                        @click="setAgentLogVersion(item,i)"
                        :value="item">

                      <v-list-item-content>

                        <div class="justify-start align-center d-flex flex-row ">
                          <div class="d-flex flex-column mr-2">
                            <span class="grey--text caption ">{{ item.version }}</span>
                            <site-label class="ml-auto" :sitename="item.userId == null ? 'HLagons' : 'Smartresas'"/>
                          </div>
                          <div class="body-2 ">
                            <div class="d-flex flex-column flex-column">
                              <span class="font-weight-medium mr-2" v-if="item.userId != null">{{
                                  initial(item.userName)
                                }}</span>
                              <span class="font-weight-medium mr-2" v-else>{{ initial(item.agentName) }}</span>
                              <span class="caption "> le {{
                                  _formatDate(new Date(item.creationDate), "dd/MM/yyyy 'à' HH:mm")
                                }}</span>
                            </div>

                          </div>

                        </div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>

                </v-col>
              </v-row>
            </v-col>

            <v-col cols="7" class="mx-4 p-6"
                   v-if="agentLogs.selected !=null && agentLogs.selected.logs.length >0 && (agentLogs.newestSelected != null && agentLogs.selected != null)">
              <comparator-json :obj2="agentLogs.oldestSelected" :obj1="agentLogs.newestSelected"
                               class="d-flex flex-column "
                               :hide-fields="['version', 'modifyDate','logType','token','autologToken']"
                               :crypted-fields="['passwordChanged']"/>
            </v-col>
          </v-row>


        </div>
      </v-tab-item>
    </v-tabs>
  </div>
</template>
<script>
import SiteLabel from "@/components/commons/SiteLabel.vue";
import ComparatorJson from "@/views/hlagons/ComparatorJson.vue";
import {get} from "@/utils/api";
import {EventBus} from "@/components/commons/event-bus";
import {capitalize} from "lodash/string";

export default {
  name: 'CrmAgencyLogs',
  components: {ComparatorJson, SiteLabel},
  props: {
    agencyId: {type: [String, Number], required: true},
    agents: {type: Array, required: false, default: () => []}
  },
  data() {
    return {
      subTabsListing: "Agences",
      logs: {
        selected: null,
        newestSelected: null,
        oldestSelected: null,
        items: null,
        loading: true,
      },
      agent: null,
      agentsLoggeds: [],
      agentLogs: {
        current: null,
        selected: null,
        selectedVersion: null,
        newestSelected: null,
        oldestSelected: null,
        items: null,
        loading: true,
        raw: null
      }
    }
  },
  created() {
    EventBus.$on("reloadLogs", () => {
      this.agentLogs.selected = null
      this.init()
    })
    this.init()
  },
  methods: {

    init() {
      this.logs.items = null
      this.logs.loading = true
      this.agentLogs.loading = true

      const url = `/api/agency/${this.agencyId}/logs`;
      get(url)
          .badRequest((br) => {
            this.agentLogs.loading = false
            this.logs.loading = false
            console.log("Error: ", br)
          })
          .json((rs) => {
            const data = rs.filter(obj => obj.data.logType === "Agency")
            const logsAgent = rs.filter(obj => obj.data.logType === "Agent")

            this.formatLogsAgency(data)
            this.formatLogsAgent(logsAgent)

            this.agentLogs.loading = false
            this.logs.loading = false
          })
    },
    formatLogsAgency(data) {
      this.logs.current = data.shift()
      this.logs.current.data.data = {...this.logs.current.data, version: "Version enregistrée"}

      const items = [...data.map(d => {
        d.data.data = {...d.data.data, version: "#" + d.agencyId + "-" + d.id}
        return {...d, version: "#" + d.id}
      })].sort(function (a, b) {
        return new Date(b.creationDate) - new Date(a.creationDate)
      });

      this.logs =
          {
            ...this.logs,
            loading: false,
            items: items
          }


      if (this.logs.items.length > 0) {
        this.selectLog(this.logs.items[0], 0)
      } else {
        this.logs.selected = null
      }
    },

    formatLogsAgent(logsAgent) {
      const agentsRow = JSON.parse(JSON.stringify(logsAgent))
      this.agentLogs.items = agentsRow.filter(agent => agent.id == null).map(agent => {

            const logs = logsAgent.filter(log => {
              return log.data.id == agent.data.id
            }).map(ver => {
              return {...ver, version: "#" + ver.id}

            }).sort(function (a, b) {
              return new Date(b.creationDate) - new Date(a.creationDate);
            })

            const current = logs.filter(log => log.data.id == agent.data.id && log.userId == null && log.agentId == null && log.origin == null).map(row => row.data)

            return {
              ...agent,
              current: current.length > 0 ? current[0] : null,
              logs: logs.length > 0 ? logs.filter(log => log.id != null) : [],
              lastUpdate: logs.length > 1 ? logs[1].creationDate : null,
            }
          }
      ).sort(function (a, b) {
        if (a.data && a.data.lastname != null && b.data && b.data.lastname != null) {
          const alpha = a.data.lastname.localeCompare(b.data.lastname)
          const date = new Date(b.lastUpdate) - new Date(a.lastUpdate);
          return date || alpha
        } else return new Date(b.lastUpdate) - new Date(a.lastUpdate)
      })

    },

    selectLog(item, i) {
      this.logs.selected = item
      if (i == 0) {
        this.logs.oldestSelected = this.logs.current.data.data
      } else {
        this.logs.oldestSelected = {
          ...this.logs.items[i - 1].data,
          version: "#" + this.agencyId + "-" + this.logs.items[i - 1].id
        }
      }
      this.logs.newestSelected = {...item.data, version: "#" + this.agencyId + "-" + item.data.id}
    },

    selectAgent(item) {
      if (this.agentLogs.selected == null || this.agentLogs.selected != item) {
        this.agentLogs.selected = item
        this.agentLogs.oldestSelected = null
        this.agentLogs.newestSelected = null
        this.agentLogs.selectedVersion = null
      }
    },

    setAgentLogVersion(item, i) {
      this.agentLogs.newestSelected = null
      this.agentLogs.oldestSelected = null
      this.agentLogs.selectedVersion = item

      if (i == 0) {

        this.agentLogs.newestSelected = {
          ...item.data,
          modifyDate: item.creationDate,
          version: "Version enregistrée"
        }

        this.agentLogs.oldestSelected = {...this.agentLogs.selected.current, modifyDate: item.creationDate}
      } else {
        this.agentLogs.oldestSelected = {
          ...this.agentLogs.selected.logs[i - 1].data,
          modifyDate: this.agentLogs.selected.logs[i].creationDate
        }

        this.agentLogs.newestSelected = {
          ...item.data,
          version: "#" + item.id + "-" + this.agentLogs.selected.logs[i].id,
          modifyDate: this.agentLogs.selected.logs[i].creationDate
        }
        if (this.agentLogs.newestSelected.passwordChanged && this.agentLogs.oldestSelected.passwordChanged) {
          this.agentLogs.oldestSelected.passwordChanged = false
        }

      }

    },

    initial(fullName) {
      if (fullName != null && fullName != '' && fullName.split(" ").length > 0) {
        const splitted = fullName.split(" ")
        const initial = capitalize(splitted[0][0])
        splitted.shift()
        return [initial + ".", splitted.join(" ").toUpperCase()].join(" ")
      } else return fullName
    }
  }
}
</script>